module.exports = __webpack_public_path__ + "img/sv62on.42071d89.svg";